import { render } from "./NavSidebar.vue?vue&type=template&id=1617c9de&scoped=true"
import script from "./NavSidebar.vue?vue&type=script&lang=js"
export * from "./NavSidebar.vue?vue&type=script&lang=js"

import "./NavSidebar.vue?vue&type=style&index=0&id=1617c9de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1617c9de"]])

export default __exports__